import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';

export class ApprovalScopeStepInstructionsContextModel
  implements IModel<ApprovalScopeStepInstructionsContextModel>
{
  approvalScopeItemId: string = '';
  stepInstructions: string = '';
  shouldShow: boolean = false;

  toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  static create(input: any): ApprovalScopeStepInstructionsContextModel {
    if (!input) {
      return new ApprovalScopeStepInstructionsContextModel();
    }

    const model = ObjectMapper.deserialize<ApprovalScopeStepInstructionsContextModel>(
      ApprovalScopeStepInstructionsContextModel,
      input
    );

    model.stepInstructions = model.stepInstructions || '';

    return model;
  }
}
